import { z } from 'zod';

/**
 * Variables schema — describes the shape of payloads the template accepts.
 * Used by the Variables editor and the send API to validate `POST /api/send/:id` payloads.
 */

export const variableTypeSchema = z.enum(['string', 'number', 'boolean', 'date', 'url', 'email']);

export const variableDefSchema = z.object({
  key: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9_]*$/i, 'Variable keys must be alphanumeric + underscore'),
  label: z.string().max(80).optional(),
  type: variableTypeSchema.default('string'),
  required: z.boolean().default(false),
  defaultValue: z.unknown().optional(),
  example: z.unknown().optional(),
});

export const variablesSchemaSchema = z.object({
  version: z.literal(1),
  fields: z.array(variableDefSchema),
  sampleData: z.record(z.unknown()).default({}),
});

export type VariableDef = z.infer<typeof variableDefSchema>;
export type VariableType = z.infer<typeof variableTypeSchema>;
export type VariablesSchema = z.infer<typeof variablesSchemaSchema>;
